import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import styles from "./journal.module.css";
import React, { useState, useEffect } from "react";
import Loader from "../../components/Loader";
import { Helmet } from "react-helmet";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Slide, Snackbar, Typography } from "@mui/material";
import { ArrowLeft, ChevronLeft, ChevronRight, Home, X } from "react-feather";
import Footer from "../../components/Footer";
import JournalFilter from "./components/JournalFilter";
import JournalCard from "./components/JournalCard";
import JournalMobileCard from "./components/JournalMobileCard";
import AddJournal from "./components/AddJournal";
import axios from "axios";
import { TableLoaderSmall } from "../../components/LoaderC";
import dayjs from "dayjs";

const Journal = () => {
    const { getAccessTokenSilently } = useAuth0();
    const [loading, setLoading] = useState(false);
    const [contentLoading, setContentLoading] = useState(true);
    const [openAddForm, setOpenAddForm] = useState(false);
    const [openEditForm, setOpenEditForm] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMsg, setSnackbarMsg] = useState("");
    const [allData, setAllData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [filterDateRange, setFilterDateRange] = useState(null);
    const [filterData, setFilterData] = useState({ searchKey: "", property: "", user: "" });
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [deleteId, setDeleteId] = useState(0);
    const [journalDetails, setJournalDetails] = useState(null);
    const [propertyList, setPropertyList] = useState([]);
    const [tenantList, setTenantList] = useState([]);
    const [userList, setUserList] = useState([]);

    useEffect(() => {
        const getUserList = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_TENANT_API_URL + "v1/journal-user-list", {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                setUserList(response.data.data);
            }).catch(() => { });
        }

        getUserList();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        const getPropertyList = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_TENANT_API_URL + "v1/journal-property-list", {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                setPropertyList(response.data.data);
            }).catch(() => { });
        }

        getPropertyList();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        async function fetchTenants() {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            await axios.get(process.env.REACT_APP_TENANT_API_URL + "v1/journal-tenant-list", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                let tFinalList = [];
                let tFinalList2 = [];

                let templistNew = response.data.data;

                templistNew?.map((item) => {
                    tFinalList.push({ label: item.label, parent: 1 });
                    item?.options?.map((subItem) => {
                        tFinalList.push({
                            value: subItem.value,
                            label: subItem.label,
                            parent: 0,
                            propertyId: item?.id,
                        });
                        return false;
                    });

                    return false;
                });

                templistNew?.map((item) => {
                    item?.options?.map((subItem) => {
                        tFinalList2.push({
                            group_id: item?.id,
                            group: item?.label,
                            value: subItem?.value,
                            label: subItem.label
                        });
                        return false;
                    });

                    return false;
                });

                setTenantList(tFinalList2);
            }).catch((error) => { });
        }

        fetchTenants();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        const geNotificationList = async () => {
            setContentLoading(true);

            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            const queryParams = new URLSearchParams();
            if (filterDateRange && filterDateRange.length === 2 && filterDateRange[0] && filterDateRange[1]) {
                queryParams.append("start", dayjs(filterDateRange[0]).format("YYYY-MM-DD"));
                queryParams.append("end", dayjs(filterDateRange[1]).format("YYYY-MM-DD"));
            }

            axios(process.env.REACT_APP_TENANT_API_URL + "v1/journals?" + queryParams.toString(), {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                setContentLoading(false);
                setAllData(response.data.data);
            }).catch(() => {
                setContentLoading(false);
            });
        }

        geNotificationList();
    }, [getAccessTokenSilently, filterDateRange]);

    useEffect(() => {
        let filteredDataTemp = allData;

        if (filterData?.searchKey !== "") {
            let inputVal = filterData?.searchKey.toLowerCase();
            filteredDataTemp = filteredDataTemp.filter((item) => {
                const titleMatch = item.title?.toLowerCase().includes(inputVal);
                const descMatch = item.description?.replace(/<[^>]*>/g, '').toLowerCase().includes(inputVal);
                const propMatch = item.property_name?.toLowerCase().includes(inputVal);
                const userMatch = item.user_name?.toLowerCase().includes(inputVal);
                
                // Format dates for checking
                const date1 = dayjs(item.date).format("MM/DD/YYYY").toLowerCase();
                const date2 = dayjs(item.date).format("MMM DD, YYYY").toLowerCase();
                const dateMatch = date1.includes(inputVal) || date2.includes(inputVal);
                
                // Tenant names check
                let tenantMatch = false;
                if (item.tenant_names) {
                    tenantMatch = item.tenant_names.toLowerCase().includes(inputVal);
                } else if (item.tenant_name) {
                    tenantMatch = item.tenant_name.toLowerCase().includes(inputVal);
                } else if (item.tenants && tenantList?.length > 0) {
                    const tenantIds = String(item.tenants).split(",").map(id => parseInt(id.trim(), 10));
                    const names = tenantIds
                        .map(id => {
                            const match = tenantList.find(t => t.value === id);
                            return match ? match.label : null;
                        })
                        .filter(name => name !== null);
                    tenantMatch = names.some(name => name.toLowerCase().includes(inputVal));
                }

                return titleMatch || descMatch || propMatch || userMatch || dateMatch || tenantMatch;
            });
        }

        if (filterData.property !== "" && filterData.property !== "all") {
            filteredDataTemp = filteredDataTemp.filter((i) => i.property_id === filterData.property);
        }

        if (filterData.user !== "" && filterData.user !== "all") {
            filteredDataTemp = filteredDataTemp.filter((i) => i.added_by === filterData.user);
        }

        setFilteredData(filteredDataTemp);
    }, [allData, filterData]);

    const deleteConfirm = async () => {
        setLoading(true);
        setDeleteModalOpen(false);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        return axios.delete(process.env.REACT_APP_TENANT_API_URL + 'v1/journals/' + deleteId, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(response => {
            setLoading(false);
            setSnackbarMsg(response.data.message);
            setSnackbarOpen(true);

            setAllData(prev => {
                return prev.filter(i => i?.id !== deleteId);
            });

            setDeleteId(0);
        }).catch(error => {
            setLoading(false);
        });
    }

    const addJournal = (data) => {
        setAllData(prev => {
            return [data].concat(prev);
        })
    }

    const updateJournal = (data) => {
        setAllData(prev => {
            return prev?.map(i => {
                if (i?.id === data?.id) {
                    return data;
                }
                return i;
            });
        })
    }

    const groupByMonth = (data) => {
        const groups = {};
        const sortedData = [...data].sort((a, b) => dayjs(b.date).unix() - dayjs(a.date).unix());
        sortedData.forEach(item => {
            const monthYear = dayjs(item.date).format("MMMM YYYY");
            if (!groups[monthYear]) {
                groups[monthYear] = [];
            }
            groups[monthYear].push(item);
        });
        return groups;
    };

    const groupedJournals = groupByMonth(filteredData || []);

    return (<>
        {loading && <Loader />}

        <Helmet title="Journals" />

        <div className={`${styles.pageTitleWrap}`}>
            <Typography display="inline" className={`${styles.pageTitle}`}>Journal</Typography>
            <nav aria-label="breadcrumb">
                <ol className={`${styles.breadcrumb}`}>
                    <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Journal</li>
                    <li className={`${styles.breadcrumbItem} ${styles.active}`}>List</li>
                </ol>
            </nav>
        </div>

        <div className={`${styles.BodyCon}`}>
            <div className={`${styles.mainCardDiv}`}>
                <div className={`${styles.mainCard}`}>



                    <div className="control-pane">
                        <div className={`${styles.Row}`}>

                            <JournalFilter filterDateRange={filterDateRange} propertyList={propertyList} userList={userList} setFilterData={setFilterData.bind(this)} setOpenAddForm={setOpenAddForm.bind(this)} setFilterDateRange={setFilterDateRange.bind(this)} />

                            {/*contentLoading && (<div className="Loader TableLoader">
                                <TableLoaderSmall />
                            </div>)*/}

                            <div className={`${styles.IncomeListingBody}`}>
                                {!contentLoading && Object.keys(groupedJournals).map(monthYear => (
                                    <React.Fragment key={monthYear}>
                                        <div className={styles.monthHeader}>
                                            <span>{monthYear}</span>
                                        </div>
                                        {groupedJournals[monthYear].map(item => (
                                            <JournalCard 
                                                key={item.id} 
                                                item={item} 
                                                tenantList={tenantList}
                                                setDeleteId={setDeleteId.bind(this)} 
                                                setDeleteModalOpen={setDeleteModalOpen.bind(this)} 
                                            />
                                        ))}
                                    </React.Fragment>
                                ))}
                                {contentLoading && (<div className="Loader TableLoader">
                                    <TableLoaderSmall />
                                </div>)}
                            </div>

                            <div className={`${styles.ListMobileView}`}>
                                {!contentLoading && Object.keys(groupedJournals).map(monthYear => (
                                    <React.Fragment key={monthYear}>
                                        <div className={styles.monthHeader}>
                                            <span>{monthYear}</span>
                                        </div>
                                        {groupedJournals[monthYear].map(item => (
                                            <JournalMobileCard 
                                                key={item.id} 
                                                item={item} 
                                                tenantList={tenantList} 
                                                setDeleteId={setDeleteId.bind(this)} 
                                                setDeleteModalOpen={setDeleteModalOpen.bind(this)} 
                                                setOpenEditForm={setOpenEditForm.bind(this)} 
                                                setJournalDetails={setJournalDetails.bind(this)} 
                                                setLoading={setLoading.bind(this)} 
                                            />
                                        ))}
                                    </React.Fragment>
                                ))}

                                {contentLoading && (<div className="Loader TableLoader">
                                    <TableLoaderSmall />
                                </div>)}
                            </div>

                            {!contentLoading && filteredData.length === 0 && (<div className={`${styles.NoDataMain}`}>
                                <div className={`${styles.NoDataIMG}`}>
                                    <img src="/static/img/no-journal.png" alt="No Data" />
                                </div>
                                <p className={`${styles.NoDataText}`}>All clear!</p>
                                <p className={`${styles.NoDataTextSub}`}>No unusual activities have been reported this week.</p>
                            </div>)}
                        </div>

                    </div>
                </div>
            </div>

            <Dialog
                open={openAddForm}
                onClose={(e) => setOpenAddForm(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="NewPopUp MobileForm"
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle id="alert-dialog-title">
                    <button className={`${styles.BackAddBU}`} onClick={(e) => setOpenAddForm(false)}><ArrowLeft /></button>
                    Add New Journal
                    <button onClick={(e) => setOpenAddForm(false)}><X /></button>
                </DialogTitle>
                <DialogContent className={`${styles.RequestBodyPop}`}>
                    <AddJournal journalData={null} propertyList={propertyList} allTenantList={tenantList} setOpenAddForm={setOpenAddForm.bind(this)} setLoading={setLoading.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} onSubmitLocal={addJournal.bind(this)} />
                </DialogContent>
            </Dialog>

            <Dialog
                open={openEditForm}
                onClose={(e) => setOpenEditForm(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="NewPopUp MobileForm"
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle id="alert-dialog-title">
                    <button className={`${styles.BackAddBU}`} onClick={(e) => setOpenEditForm(false)}><ArrowLeft /></button>
                    Edit Journal
                    <button onClick={(e) => setOpenEditForm(false)}><X /></button>
                </DialogTitle>
                <DialogContent className={`${styles.RequestBodyPop}`}>
                    <AddJournal journalData={journalDetails} propertyList={propertyList} allTenantList={tenantList} setOpenAddForm={setOpenEditForm.bind(this)} setLoading={setLoading.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} onSubmitLocal={updateJournal.bind(this)} />
                </DialogContent>
            </Dialog>

            <Dialog
                open={deleteModalOpen}
                onClose={(e) => setDeleteModalOpen(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="NewPopUp"
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle id="alert-dialog-title">Are you sure you want to delete the journal?<button onClick={(e) => setDeleteModalOpen(false)}><X /></button></DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <div className="ModalFormGroup">
                            <label className="PopupBodyText">The journal will be removed immediately. You can't undo this action.</label>
                        </div>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <button className="CancelPopupBU" onClick={(e) => deleteConfirm()}>Delete</button>
                    <button onClick={(e) => setDeleteModalOpen(false)} className="SubmitPopupBU">Cancel</button>
                </DialogActions>
            </Dialog>


        </div>

        <Footer />

        <Snackbar
            open={snackbarOpen}
            onClose={(e) => setSnackbarOpen(false)}
            TransitionComponent={Slide}
            message={snackbarMsg}
            autoHideDuration={10000}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            action={
                <IconButton
                    size="small"
                    aria-label="close"
                    color="inherit"
                    onClick={(e) => setSnackbarOpen(false)}
                >
                    <X />
                </IconButton>
            }
        />
    </>);
};

export default withAuthenticationRequired(Journal, {
    onRedirecting: () => <Loader />,
});